export const APP_VIEWCONTAINERREF_CHANGED = 'APP_VIEWCONTAINERREF_CHANGED';
